import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  bulletIcon: {
    height: 10,
    width: 10,
    color: '#DF0C36',
  },
  listItemText: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#666666',
    textAlign: 'left',
  },
  listItem: {
    height: '95px',
    padding: '30px 20px',
  },
  paperPopper: {
    backgroundColor: theme.palette.background.paper,
    width: 350,
  },
  grid: {
    paddingBottom: 0,
    height: '50px',
  },
  listItemIcon: {
    minWidth: 20,
  },
  activeCheckButton: { color: '#DF0C36' },
  disabledCheckButton: { color: '#CCCCCC' },
  popperStyle: {
    maxHeight: 450,
    overflowY: 'auto',
    zIndex: '1499',
    border: '2px solid #ccc',
  },
  emptyPopperStyle: {
    maxHeight: 0,
    overflowY: 'hidden',
    border: 'none',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '14px',
    color: '#666666',
    textAlign: 'left',
    marginTop: 20,
    marginLeft: 12,
  },
  filterIcon: {
    color: '#DADADA',
    marginTop: 15,
    cursor: 'pointer',
  },
  redFilterIcon: {
    color: '#DF0C36',
    marginTop: 15,
    cursor: 'pointer',
  },
  dialogTitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '36px',
    color: '#666666',
    marginTop: 16,
  },
  subTitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '20px',
    color: '#828282',
  },
  dialogText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
  },
  largeFilterIcon: {
    color: '#DF0C36',
    marginTop: 30,
    marginLeft: 20,
  },
  closeIcon: {
    padding: '0 !important',
    marginTop: '25px !important',
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  cancelButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    color: '#DF0C36',
    borderColor: '#DF0C36',
    borderRadius: 0,
    marginRight: '24px',
    '&:hover': {
      color: '#B00429',
      borderColor: '#B00429',
      backgroundColor: '#FFFFFF',
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 290,
    maxWidth: 450,
  },
  root: {
    '&$checked': {
      color: '#DF0C36',
    },
  },
  checked: {},
  icon: { color: '#DF0C36' },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  dropdownStyle: {
    maxHeight: '15rem',
    transitionDuration: '0s !important',
    transformOrigin: '0 !important',
    transition: 'none !important',
    'div.MuiPaper-root': {
      transition: 'none !important',
    },
  },
  selectMenuPopover: {
    zIndex: '1550 !important',
  },
  dialog: {
    height: 180,
  },
  dialogStyle: {
    zIndex: '1501 !important',
  },
}));
